<template>
  <div class="maxbox">
    <div>
      <div class="top">
        <p>每日收益记录</p>
      </div>
      <div class="main">
        <button @click="goBack" class="return">
          <img src="@/assets/images/left-arrow.png" alt="返回">
        </button>
        <div class="data-card">
          <div class="card-item">
            <span class="label">累计总收益：</span>
            <span class="value">{{ totalAllIncome }} TND</span>
          </div>
        </div>
        <div class="history-title">结算分红历史(矿机+各级推荐)</div>
        <div class="history-list-box" ref="scrollBox">
          <div class="history-list">
            <div class="list-item" v-for="(item) in pageRecords" :key="`round-${item.settleRoundId}`">
              <div class="left-info">
                <span class="date-text">{{ item.settleTime }}</span>
              </div>
              <div class="right-info">
                <div class="profit-row mine-row">
                  <span>🏭 矿机收益</span>
                  <span>{{ formatAmount(item.mineProfit) }} TND</span>
                </div>
                <div class="profit-row">
                  <span>👥 一代推荐</span>
                  <span>{{ formatAmount(item.level1Profit) }} TND</span>
                </div>
                <div class="profit-row">
                  <span>👥 二代推荐</span>
                  <span>{{ formatAmount(item.level2Profit) }} TND</span>
                </div>
                <div class="profit-row">
                  <span>👥 3-10级团队</span>
                  <span>{{ formatAmount(item.level3To10Profit) }} TND</span>
                </div>
                <div class="profit-row total-row">
                  <span>💰 本轮合计</span>
                  <span>{{ formatAmount(item.totalRoundProfit) }} TND</span>
                </div>
              </div>
            </div>
            <div class="empty-tip" v-if="sortedAllRecords.length === 0">
              暂无结算记录，等待管理员执行分红结算<br>
              <span style="font-size:12px;color:#bbb">注：子图存在索引延迟，分红后需等待几十秒数据同步</span>
            </div>
          </div>
        </div>
        <div class="pagination-wrap" v-if="sortedAllRecords.length > 0">
          <button :disabled="currentPage <= 1" @click="prevPage">上一页</button>
          <span class="page-text">第{{ currentPage }}页 / 共{{ totalPage }}页（共{{ sortedAllRecords.length }}条）</span>
          <button :disabled="currentPage >= totalPage" @click="nextPage">下一页</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { ethers } from 'ethers'
import { contractAddress, contractABI } from '@/js/contract.js'
const DECIMAL = 6
const ZERO_BN = ethers.BigNumber.from(0)
// 内部会员查询：旧Studio地址，稳定无需API Key
const GRAPH_URL = "https://gateway.thegraph.com/api/subgraphs/id/C95kzECu3rd3igQsGfTW6hN11Tw37hp9RyDsVdiMmpGx"

export default {
  name: "shouyi",
  data() {
    return {
      contract: null,
      signer: null,
      userAddr: "",
      totalAllIncome: "0.000000",
      totalMineIncome: "0.000000",
      totalReferIncome: "0.000000",
      settleRecords: [],
      maxDisplayRounds: 20,
      isRecordArchived: false,
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    sortedAllRecords() {
      if (this.isRecordArchived) return []
      let list = [...this.settleRecords]
      list.sort((a, b) => Number(b.settleRoundId) - Number(a.settleRoundId))
      return list
    },
    totalPage() {
      return Math.ceil(this.sortedAllRecords.length / this.pageSize)
    },
    pageRecords() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.sortedAllRecords.slice(start, end)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    scrollListToTop() {
      if (this.$refs.scrollBox) {
        this.$refs.scrollBox.scrollTop = 0
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--
        this.scrollListToTop()
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPage) {
        this.currentPage++
        this.scrollListToTop()
      }
    },
    async init() {
      if (!window.ethereum) return alert("请安装钱包插件")
      try {
        const provider = new ethers.providers.Web3Provider(window.ethereum)
        await provider.send("eth_requestAccounts", [])
        this.signer = provider.getSigner()
        this.userAddr = (await this.signer.getAddress()).toLowerCase()
        this.contract = new ethers.Contract(contractAddress, contractABI, this.signer)
      } catch (err) {
        console.log("钱包初始化失败", err)
        return
      }
      this.isRecordArchived = false
      try {
        if (this.contract && this.contract.userRecordArchived) {
          this.isRecordArchived = await this.contract.userRecordArchived(this.userAddr)
        }
      } catch (err) {
        console.log("userRecordArchived 函数不存在，跳过校验", err.message)
      }
      if (this.isRecordArchived) {
        this.settleRecords = []
        return
      }
      await Promise.all([
        this.getTotalChainData(),
        this.getHistoryFromGraph()
      ]).catch(e => console.log("加载数据异常", e))
    },
    async getTotalChainData() {
      try {
        const totalAll = await this.contract.getTotalDividends()
        const lv1 = await this.contract.getFirstLevelBonus()
        const lv2 = await this.contract.getSecondLevelBonus()
        const lv310 = await this.contract.getThirdToTenthLevelBonus()
        const totalRefer = lv1.add(lv2).add(lv310)
        const totalMine = totalAll.sub(totalRefer)
        this.totalAllIncome = ethers.utils.formatUnits(totalAll, DECIMAL)
        this.totalReferIncome = ethers.utils.formatUnits(totalRefer, DECIMAL)
        this.totalMineIncome = ethers.utils.formatUnits(totalMine.lt(ZERO_BN) ? ZERO_BN : totalMine, DECIMAL)
      } catch (e) {
        console.log("读取收益数据失败", e)
      }
    },
    // 分页循环拉取全部矿机+推荐事件，修复first:1000截断导致部分轮次缺失层级奖励
    async getHistoryFromGraph() {
      try {
        const allMine = []
        const allRefer = []
        let skipMine = 0
        let skipRefer = 0
        const pageSize = 1000
        // 正式网关必须携带鉴权Header，测试Studio不需要
        const authHeaders = {
          "Content-Type": "application/json",
          "Authorization": "Bearer 8f9c604fdd39444789841cbead617821"
        }
        // 循环拉取全部矿机奖励事件
        while (true) {
          const mineQuery = `
        query Mine($user: Bytes!, $skip: Int!) {
          mineRewardRecords(where:{user:$user}, orderBy:blockNumber, orderDirection:desc, first:1000, skip:$skip) {
            user
            settleRoundId
            settleTimestamp
            amount
            blockNumber
          }
        }
      `
          const mineRes = await fetch(GRAPH_URL, {
            method: "POST",
            headers: authHeaders, // 替换成带Bearer的头部
            body: JSON.stringify({
              query: mineQuery,
              // 切掉0x前缀，适配正式网关Bytes严格校验
              variables: { user: this.userAddr.slice(2), skip: skipMine }
            })
          })
          const mineJson = await mineRes.json()
          if (!mineJson || !mineJson.data || !mineJson.data.mineRewardRecords) {
            console.error("矿机记录接口返回异常", mineJson)
            break
          }
          const list = mineJson.data.mineRewardRecords
          if (list.length === 0) break
          allMine.push(...list)
          skipMine += pageSize
          // 安全上限，防止死循环
          if (skipMine > 100000) break
        }
        // 循环拉取全部推荐奖励事件（修复：保留完整query字段）
        while (true) {
          const referQuery = `
        query Refer($user: Bytes!, $skip: Int!) {
          referralRewardRecords(where:{receiver:$user}, orderBy:blockNumber, orderDirection:desc, first:1000, skip:$skip) {
            receiver
            fromUser
            level
            settleRoundId
            amount
            settleTimestamp
            blockNumber
          }
        }
      `
          const referRes = await fetch(GRAPH_URL, {
            method: "POST",
            headers: authHeaders,
            body: JSON.stringify({
              query: referQuery, // 之前漏掉这一行导致报错，现已补回
              variables: { user: this.userAddr.slice(2), skip: skipRefer }
            })
          })
          const referJson = await referRes.json()
          if (!referJson || !referJson.data || !referJson.data.referralRewardRecords) {
            console.error("推荐记录接口返回异常", referJson)
            break
          }
          const list = referJson.data.referralRewardRecords
          if (list.length === 0) break
          allRefer.push(...list)
          skipRefer += pageSize
          if (skipRefer > 100000) break
        }
        // 下面聚合分级收益逻辑和你测试网旧代码完全一致，无需改动
        const roundMap = {}
        for (const m of allMine) {
          const roundId = m.settleRoundId
          if (!roundMap[roundId]) {
            roundMap[roundId] = {
              settleRoundId: roundId,
              settleTimestamp: Number(m.settleTimestamp),
              mineProfit: ZERO_BN,
              level1Profit: ZERO_BN,
              level2Profit: ZERO_BN,
              level3To10Profit: ZERO_BN
            }
          }
          roundMap[roundId].mineProfit = roundMap[roundId].mineProfit.add(m.amount)
        }
        for (const r of allRefer) {
          const roundId = r.settleRoundId
          if (!roundMap[roundId]) {
            roundMap[roundId] = {
              settleRoundId: roundId,
              settleTimestamp: Number(r.settleTimestamp),
              mineProfit: ZERO_BN,
              level1Profit: ZERO_BN,
              level2Profit: ZERO_BN,
              level3To10Profit: ZERO_BN
            }
          }
          const bnAmt = ethers.BigNumber.from(r.amount)
          if (Number(r.level) === 1) {
            roundMap[roundId].level1Profit = roundMap[roundId].level1Profit.add(bnAmt)
          } else if (Number(r.level) === 2) {
            roundMap[roundId].level2Profit = roundMap[roundId].level2Profit.add(bnAmt)
          } else {
            roundMap[roundId].level3To10Profit = roundMap[roundId].level3To10Profit.add(bnAmt)
          }
        }
        this.settleRecords = Object.values(roundMap).map(item => {
          const mine = item.mineProfit
          const l1 = item.level1Profit
          const l2 = item.level2Profit
          const l310 = item.level3To10Profit
          const total = mine.add(l1).add(l2).add(l310)
          return {
            settleRoundId: Number(item.settleRoundId),
            settleTimestamp: item.settleTimestamp,
            settleTime: this.timeFormat(item.settleTimestamp),
            mineProfit: mine,
            level1Profit: l1,
            level2Profit: l2,
            level3To10Profit: l310,
            totalRoundProfit: total
          }
        })
        this.currentPage = 1
        this.scrollListToTop()
      } catch (e) {
        console.log("Graph查询失败", e)
        this.settleRecords = []
      }
    },


    formatAmount(bigNum) {
      if (!bigNum) return "0.000000"
      return ethers.utils.formatUnits(bigNum, DECIMAL)
    },
    timeFormat(timestamp) {
      if (!timestamp) return '未知时间'
      const d = new Date(Number(timestamp) * 1000)
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`
    }
  }
}

</script>

<style scoped>
@import "@/assets/css/style.css";
@import "@/assets/css/detill.css";

.data-card {
  margin: 30px 0;
  background: #fff;
  border-radius: 16px;
  padding: 25px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
}

.card-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
}

.card-item .label {
  font-size: 16px;
  color: #666;
}

.card-item .value {
  font-size: 17px;
  color: #333;
  font-weight: 500;
}

.history-title {
  margin: 30px 0 16px;
  font-size: 17px;
  color: #333;
  font-weight: 500;
}

.history-list-box {
  height: 410px;
  overflow-y: auto;
  padding-right: 5px;
  border-radius: 12px;
}

.list-item {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 16px;
}

.date-text {
  font-size: 14px;
  color: #999;
  margin-top: 8px;
  display: block;
}

.right-info {
  width: 60%;
}

.profit-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin: 4px 0;
  color: #666;
}

.mine-row {
  color: #16a085;
  font-weight: 500;
}

.total-row {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px dashed #eee;
  color: #007AFF;
  font-weight: bold;
}

.empty-tip {
  text-align: center;
  font-size: 14px;
  color: #999;
  padding-top: 80px;
}

.main {
  padding-top: 30px;
  padding-bottom: 80px;
  min-height: 750px;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  margin-top: 14px;
  margin-bottom: 20px;
}

.pagination-wrap button {
  border: none;
  background: #007AFF;
  color: #fff;
  border-radius: 6px;
  padding: 6px 14px;
  font-size: 14px;
}

.pagination-wrap button:disabled {
  background: #cccccc;
}

.page-text {
  font-size: 13px;
  color: #666;
}
</style>
